// ============================================================================
// Main entry — bootstraps Fancybox / jquery-confirm / smooth scroll
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Fancybox !== 'undefined') {
            Fancybox.bind('[data-fancybox]', {});
        }

        if ($.alert) {
            $.alert.defaults = $.extend($.alert.defaults, {
                theme: 'modern',
                animation: 'scale',
                closeAnimation: 'scale',
                animationSpeed: 250,
                backgroundDismiss: true,
            });
        }

        // Smooth scroll for in-page anchors — uses native CSS scroll-behavior, honours target's scroll-margin-top so it lands below the sticky header. Don't use jQuery .animate({ scrollTop }) here — it fights the CSS smoothing.
        $(document).on('click', 'a[href^="#"]:not([href="#"]):not(.skip-link)', function (e) {
            const target = $(this.getAttribute('href'));
            if (!target.length) return;
            e.preventDefault();

            const node = target[0];
            const cs = window.getComputedStyle(node);
            let offset = parseFloat(cs.scrollMarginTop) || 0;
            if (!offset) {
                const $header = $('#header');
                if ($header.length) offset = $header.outerHeight() || 0;
            }

            const top = Math.max(0, node.getBoundingClientRect().top + window.pageYOffset - offset);
            window.scrollTo({ top: top, behavior: 'smooth' });
        });
    });
})(jQuery);
